import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiAnchor, FiBriefcase } = FiIcons;

const AboutUs = () => {
  return (
    <div className="pt-24 bg-stone-50 min-h-screen">
      {/* Header Section */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-12 bg-emerald-600" />
              <span className="text-emerald-600 font-bold uppercase tracking-[0.2em] text-xs">Ammerland / Niedersachsen</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-stone-900 mb-12 leading-tight">
              Über CoreUnit Systems
            </h1>
            
            <div className="space-y-12">
              <p className="text-2xl md:text-3xl text-stone-700 leading-relaxed font-medium border-l-4 border-emerald-500 pl-8">
                CoreUnit Systems entsteht im Ammerland, Niedersachsen — mit dem Ziel, pharmazeutische Präzision und industrielle Mobilität in einem System zu vereinen.
              </p>

              <div className="grid md:grid-cols-2 gap-12 pt-8">
                <div className="space-y-6">
                  <div className="flex items-center gap-4 text-emerald-600">
                    <SafeIcon icon={FiMapPin} className="text-2xl" />
                    <h3 className="text-xl font-bold text-stone-900">Hub Westerstede</h3>
                  </div>
                  <p className="text-stone-600 leading-relaxed text-lg">
                    Unser operativer Hub entsteht in Westerstede. Dort entwickeln, bauen und testen wir den Alchemist — eine mobile Reinraum-Einheit, die ihren Betreibern die Kontrolle über ihre eigene Pflanzenproduktion zurückgibt.
                  </p>
                </div>

                <div className="space-y-6 bg-white p-8 rounded-[32px] border border-stone-200 shadow-sm">
                  <div className="flex items-center gap-4 text-stone-900">
                    <SafeIcon icon={FiBriefcase} className="text-2xl" />
                    <h3 className="text-xl font-bold">Identität</h3>
                  </div>
                  <p className="text-stone-600 leading-relaxed text-lg">
                    Wir sind Anlagenbauer. Unsere Kunden sind die Produzenten.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Founder Block */}
      <section className="py-20 bg-stone-900 text-white overflow-hidden relative">
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-5 pointer-events-none">
          <SafeIcon icon={FiAnchor} className="w-full h-full text-emerald-500 -rotate-12 translate-x-1/4" />
        </div>
        
        <div className="max-w-4xl mx-auto px-6 relative z-10">
          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="border-t border-stone-800 pt-16"
          >
            <div className="max-w-md">
              <span className="text-emerald-500 font-bold uppercase tracking-widest text-[10px] mb-4 block">Führung</span>
              <h2 className="text-3xl font-bold mb-2">Martin Habibi</h2>
              <p className="text-stone-400 text-lg">Gründer & Geschäftsführer</p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Location Footer / Visual */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 opacity-40 grayscale">
          <div className="flex items-center gap-4">
            <SafeIcon icon={FiMapPin} />
            <span className="font-bold tracking-tighter">AMMERLAND STATE</span>
          </div>
          <div className="flex items-center gap-4">
            <SafeIcon icon={FiAnchor} />
            <span className="font-bold tracking-tighter">NORDDEUTSCHLAND</span>
          </div>
          <div className="flex items-center gap-4">
            <SafeIcon icon={FiBriefcase} />
            <span className="font-bold tracking-tighter">ANLAGENBAU</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;